// Owner-only control on a team member: delegate Bank Feeds (none / view /
// manage) for this business. The owner always has both.
import React, { useState } from 'react';
import { invitesAPI } from '../services/invitesApi';
import { formatApiError } from '../../../utils/errorMessage';
import { BANK_FEED_LEVELS, bankFeedLevel } from '../../bank-feeds/bankFeedPermissions';

export default function BankFeedsAccess({ businessId, member, onSaved }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const change = async (value) => {
    const level = BANK_FEED_LEVELS.find((l) => l.value === value);
    setSaving(true); setError('');
    try {
      await invitesAPI.updateMemberBankFeeds(businessId, member.user_id, level.permissions);
      if (onSaved) await onSaved();
    } catch (e) { setError(formatApiError(e, 'Could not save Bank Feeds access')); }
    setSaving(false);
  };
  return (
    <label className="inline-flex items-center gap-1 text-sm">
      Bank Feeds
      <select value={bankFeedLevel(member.granted_permissions)} onChange={(e) => change(e.target.value)} disabled={saving}
        aria-label={`Bank Feeds access for ${member.email || 'member'}`} className="border rounded px-2 py-1 text-sm">
        {BANK_FEED_LEVELS.map((l) => <option key={l.value} value={l.value}>{l.label}</option>)}
      </select>
      {error && <span role="alert" className="text-red-600 text-xs">{error}</span>}
    </label>
  );
}
